import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import { Avatar, Divider, IconButton, List, ListItem, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { Close, Logout } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import MenuIcon from "@mui/icons-material/Menu";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import { AUTH } from 'app/utils/constants/endPoint';
import { requestApi } from 'app/utils/RestApi';
import { removeToken } from '@jumbo/components/JumboAuthProvider/authHelpers';
import Swal from 'sweetalert2';


const TopNavBar = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);


  const navigate = useNavigate();

  const location = useLocation();

  const menus = [
    {
      link: '/micrositeNews',
      text: 'News'
    },
    {
      link: '/micrositeListLeads',
      text: 'Lead Listing'
    },
    {
      link: '/micrositeHistoryPayment',
      text: 'History Payment'
    },
    {
      link: '/micrositeDokument',
      text: 'Documents'
    },
  ]

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async () => {
    Swal.showLoading()
    await requestApi(AUTH.LOGOUT, {}).then((data) => {
      
    }).catch((err) => {
      console.log('logout err ', err);
    }).finally(() => {
      setTimeout(() => {
        Swal.close()
        removeToken()
      }, 3000);
    })
  };

  const destroyEl = () => {
    setAnchorEl(null);
  };

  // sidebar
  const [screenSize, setScreenSize] = React.useState(getCurrentDimension());

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    }
  }

  React.useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension())
    }
    window.addEventListener('resize', updateDimension);


    return (() => {
      window.removeEventListener('resize', updateDimension);
    })
  }, [screenSize])

  const [state, setState] = React.useState(false);

  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
    >
      <Div className='flex-justify-end'>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={() => setState(false)}
        >
          {
            <Close sx={{ color: "#000000" }} />
          }
        </IconButton>
      </Div>
      <List>
        {
          menus.map((m, idx) => (
            <ListItem key={m.text} className={location.pathname.includes(m.link) ? "side-menu-item active" : "side-menu-item"} sx={{ padding: "16px" }}>
              <Link key={m.text} href={m.link} underline="none">
                {m.text}
              </Link>
            </ListItem>
          ))
        }
      </List>
      <Divider />
      <List>
        <ListItem
          sx={{ padding: "16px" }}
          onClick={() => navigate('/micrositeProfile')}
          className={location.pathname.includes('micrositeProfile') ? "side-menu-item active" : "side-menu-item"}
        >
          Profile
        </ListItem>
        <ListItem
          sx={{ padding: "16px" }}
          onClick={handleClose} className='side-menu-item'>
          <ListItemIcon sx={{ minWidth: '24px' }}>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </ListItem>
      </List>
    </Box>
  );

  return (
    <AppBar position="fixed" sx={{ backgroundColor: 'transparent' }} elevation={0}>
      <Div
        className='header-wrapper'
        sx={{
          // maxWidth: '1600px',
          margin: '0 auto',
          width: '100%',
        }}>
        <Toolbar disableGutters sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {screenSize.width >= 870 ?
            <Link href="#" underline="none" sx={{ display: 'inline-flex', width: '90px' }}>
              <img alt="" src="/images/logo-generali.png" className='logo-header' />
            </Link> :
            <Link href="#" underline="none" sx={{ display: 'inline-flex', width: '90px' }}>
              <img alt="" src="/images/logo-red.svg" className='logo-header' />
            </Link>
          }
          <Div
            className='menu-desktop'
            sx={{
              backgroundColor: 'white',
              padding: '30px 30px 0',
              display: { xs: 'none', sm: 'flex' },
              flex: 1,
              justifyContent: 'center',
              alignItems: 'flex-end',
              borderRadius: "0 0 30px 30px",
              margin: "0 10px",
              height: 110,
              // maxWidth: '1600px',
              // gap: '40px'
            }}>
            {
              menus.map((m, idx) => (
                <Link key={m.text} href={m.link} underline="none"
                  className={location.pathname.includes(m.link) ? "top-nav-menu active" : "top-nav-menu"}
                  sx={{ margin: '0 20px', color: '#888888', fontSize: 18 }}>
                  {m.text}
                </Link>
              ))
            }
          </Div>
          <Div className='m-d-none'>
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2, width: '75px' }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <Avatar sx={{
                width: 60,
                height: 60,
              }} />
            </IconButton>
          </Div>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={destroyEl}
            onClick={destroyEl}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={() => navigate('/micrositeProfile')}>
              <Avatar /> Profile
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>

          {/* sibar for mobile */}
          <Div className='side-menu-icon'>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={() => setState(true)}
            >
              {
                <MenuIcon sx={{ color: "#000000" }} />
              }
            </IconButton>
          </Div>
        </Toolbar>
      </Div>
      <div>
        <React.Fragment >
          <SwipeableDrawer
            anchor={'right'}
            open={state}
            onClose={() => setState(false)}
            onOpen={() => setState(true)}
          >
            {list()}
          </SwipeableDrawer>
        </React.Fragment>
      </div>
    </AppBar>
  );
};

const mapStateToProps = state => ({
  authMicrosite: state.authMicrosite
});

export default connect(mapStateToProps)(TopNavBar);